/* eslint-disable max-len */
import Phaser from 'phaser';
import EDC from '../../shared/globals';
import { AnswerMark } from '../../shared/mark-animation';

/**
 *
 */
EDC.Games.CountingDots.Answer = function (scene, parentContainer, value, animationDistance, index, isCorrect) {
  this.scene = scene;
  this.isCorrect = isCorrect;
  this.value = value;
  this.index = index;
  this.animationDistance = animationDistance;
  this.container = null;
  this.text = null;
  this.parent = parentContainer;
  this.endX = 0;
  this.endY = 0;
  this.width = 0;
  this.isActive = true;
  this.markAnim = null;
  this.cursorManager = scene.cursorManager;
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.create = function (targetX, targetY) {
  this.endX = targetX;
  this.endY = targetY;
  this.container = this.scene.add.container(0, 0);
  const boxFrame = this.scene.add.sprite(0, 0, 'answer-box');
  this.container.add(boxFrame);

  this.text = this.scene.add
    .text(0, 0, this.value, {
      fontFamily: 'Arial',
      fontSize: 130,
      fill: '#000000',
      fontStyle: 'bold',
    })
    .setOrigin(0.5);
  this.container.add(this.text);

  this.width = boxFrame.width;

  this.markAnim = new AnswerMark(this.scene, this.container).setScale(0.45);

  this.container.setPosition(this.endX + boxFrame.width / 2, this.endY + this.animationDistance);

  this.parent.add(this.container);

  this.makeInteractive(boxFrame.width, boxFrame.height);
  return this;
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.appear = function () {
  this.scene.tweens.add({
    targets: this.container,
    y: this.endY,
    duration: 300,
    ease: 'Back.easeOut',
    delay: this.index * 60,
  });
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.disappear = function () {
  this.scene.tweens.add({
    targets: this.container,
    y: this.endY + this.animationDistance,
    duration: 300,
    ease: 'Back.easeOut',
    delay: this.index * 60,
    onComplete: () => {
      this.scene.events.emit(this.scene.signals.S_ANSWER_DISAPPEARED);
    },
  });
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.makeInteractive = function (width, height) {
  this.container.setInteractive(
    new Phaser.Geom.Rectangle(-width / 2, -height / 2, width, height),
    Phaser.Geom.Rectangle.Contains,
  );
  this.container.on('pointerup', this.onUp, this);
  this.cursorManager.setDefaultDraggableEvents(this.container);
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.onUp = function () {
  if (!this.isActive) return;
  this.isActive = false;
  if (this.isCorrect) {
    this.scene.answersBox.deactivateAnswers();
    this.markAnim.showMark(true, () => {
      this.scene.events.emit(this.scene.signals.S_ANSWER_CORRECT_CLICKED);
    });
  } else {
    this.markAnim.showMark(false, () => {
      this.scene.events.emit(this.scene.signals.S_ANSWER_WRONG_CLICKED);
    });
  }
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.getWidth = function () {
  return this.width;
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.shake = function () {
  this.scene.tweens.add({
    targets: this.container,
    angle: 8,
    duration: 70,
    ease: 'Linear',
    yoyo: true,
    repeat: 2,
  });
};
/**
 *
 */
EDC.Games.CountingDots.Answer.prototype.destroy = function () {
  this.container.destroy();
};

export default EDC.Games.CountingDots.Answer;
